"use strict";
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("../styles");
const login_1 = __importDefault(require("../login"));
const infographic_1 = __importDefault(require("../components/infographic"));
const GenericFullPage = ({ configName, callbackVerifyOTPSuccess, r2d2, track, defaultInputValue, sitekey, disable }) => {
    return (react_1.default.createElement(styles_1.GenericFullPageLoginContainer, { alignCenter: configName === 'health' },
        react_1.default.createElement(styles_1.LeftContainer, { justifyContent: "flex-start" },
            react_1.default.createElement(styles_1.RootContainer, null,
                react_1.default.createElement(login_1.default, { configName: configName, callbackVerifyOTPSuccess: callbackVerifyOTPSuccess, r2d2: r2d2, track: track, isGenericPage: true, showNavigation: true, defaultInputValue: defaultInputValue, sitekey: sitekey, disable: disable || false }))),
        configName !== 'health' && (react_1.default.createElement(styles_1.RightContainer, null,
            react_1.default.createElement(infographic_1.default, null)))));
};
exports.default = GenericFullPage;
//# sourceMappingURL=generic-login-page.js.map